// extracted by mini-css-extract-plugin
export var author = "CustomerSlider-module--author--4d194";
export var block = "CustomerSlider-module--block--cc85f";
export var sliderHeader = "CustomerSlider-module--sliderHeader--61ab4";
export var testimonialBlock = "CustomerSlider-module--testimonialBlock--a0bce";
export var wrapper = "CustomerSlider-module--wrapper--b2db8";